import { Alert, Badge } from '@zarya/ui';
import { dataHour } from '@app/format';
import { t } from '@app/i18n';
import {
  BLOCOS_PROVENANCE,
  chipEmulacao,
  provenanceBlockLabel,
  summaryBlock,
  type ApprovalDetail,
} from './ApprovalsModel';
import s from './Approvals.module.css';

/**
 * Procedência da imagem (FR-043, FR-059): Scan · SBOM · Assinatura, cada um com
 * o chip **emulado** / **real** / "não informado".
 *
 * O chip é o ponto da tela: numa PoC quase tudo é emulado, e o aprovador precisa
 * ver isso sem abrir o middleware.
 */
export function ProvenanceCard({ detalhe }: { detalhe: ApprovalDetail }) {
  const procedencia = detalhe.release?.provenance;

  if (!procedencia || procedencia.available === false) {
    return (
      <section className={s.secao}>
        <h3 className={s.secaoTitulo}>{t('approvals.provenanceCard.title')}</h3>
        <Alert tone="warning" title={t('approvals.provenanceCard.unavailable.title')}>
          {t('approvals.provenanceCard.unavailable.body', {
            reason: procedencia?.reason ? ` (${procedencia.reason})` : '',
          })}
        </Alert>
      </section>
    );
  }

  return (
    <section className={s.secao}>
      <h3 className={s.secaoTitulo}>{t('approvals.provenanceCard.title')}</h3>
      <div className={s.blocos}>
        {BLOCOS_PROVENANCE.map((chave) => {
          const block = procedencia[chave];
          const chip = chipEmulacao(block);
          return (
            <div className={s.bloco} key={chave}>
              <span className={s.blocoNome}>{provenanceBlockLabel(chave)}</span>
              <span className={s.blocoResumo}>{summaryBlock(block)}</span>
              <Badge tone={chip.tone}>{chip.rotulo}</Badge>
            </div>
          );
        })}
      </div>
      {procedencia.read_at ? (
        <p className={s.carregando}>
          {t('approvals.provenanceCard.readAt', { when: dataHour(procedencia.read_at) ?? '—' })}
        </p>
      ) : null}
    </section>
  );
}
